export const cibDtube = ["32 32","<path d='M30.135 7.333c-1.172-2.255-2.969-4.125-5.177-5.385-2.292-1.286-4.891-1.938-7.521-1.896h-17.198l9.214 5.333h7.984c2.589 0 4.547 0.828 5.896 2.51 1.333 1.667 2 4.104 2 7.344v1.693c-0.016 3.12-0.708 5.521-2.068 7.203-1.359 1.677-3.333 2.516-5.891 2.516h-8.229l-9.146 5.281h17.505c2.786 0 5.297-0.651 7.51-1.917 2.214-1.271 3.932-3.068 5.156-5.365 1.229-2.292 1.828-4.932 1.828-7.906v-1.464c0-2.964-0.625-5.599-1.865-7.948zM0.172 5.281v21.464l18.589-10.745z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-dtube.js
// module id = null
// module chunks = 